<h1 mat-dialog-title>Delete Job</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete <b>"{{data.jobName}}"?</b></p>
  <p><i>This action cannot be undone.</i></p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button cdkFocusInitial (click)="onYesClick()">Yes</button>
</div>
